import sitemapConfig from './sitemap_config.json';
import deepmerge from 'deepmerge';

export interface ISitemapConfig {
    isMobile: boolean;
    hostname: string;
    marketToCountry: Record<string, string>;
    marketToLanguage: Record<string, string>;
    xDefault: string;
    simpleHreflangMarkets: string[];
    staticPagesRoutes: string[];
    sportsbook: string;
    duplicates: IDuplicateItem[];
    faqBaseRoute: string;
    responsibleGamingBaseRoute: string;
}

export interface IDuplicateItem {
    keep: string[];
    remove: string[];
}

let environmentConfig: Partial<ISitemapConfig> = {};

/* eslint:disable @typescript-eslint/no-var-requires */
if (process.env.VUE_APP_CONFIG_ENV === 'production') {
    environmentConfig = require('./sitemap_config.production.json');
} else {
    // config defaults to staging
    environmentConfig = require('./sitemap_config.staging.json');
}

export const config = deepmerge<ISitemapConfig>(
    sitemapConfig,
    environmentConfig,
);
